/* This file is auto-generated */

import type { ContractPromise } from '@polkadot/api-contract';
import type { GasLimit, GasLimitAndRequiredValue } from '@arthswap/typechain-types';
import { buildSubmittableExtrinsic } from '@arthswap/typechain-types';
import type * as ArgumentTypes from '../types-arguments/factory_contract';
import type BN from 'bn.js';
import type { ApiPromise } from '@polkadot/api';



export default class Methods {
	private __nativeContract : ContractPromise;
	private __apiPromise: ApiPromise;

	constructor(
		nativeContract : ContractPromise,
		apiPromise: ApiPromise,
	) {
		this.__nativeContract = nativeContract;
		this.__apiPromise = apiPromise;
	}
	/**
	 * allPairsLength
	 *
	*/
	"allPairsLength" (
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::allPairsLength", [], __options);
	}

	/**
	 * lockForPairCreate
	 *
	*/
	"lockForPairCreate" (
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::lockForPairCreate", [], __options);
	}

	/**
	 * pairContractCodeHash
	 *
	*/
	"pairContractCodeHash" (
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::pairContractCodeHash", [], __options);
	}

	/**
	 * unlockPairCreate
	 *
	*/
	"unlockPairCreate" (
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::unlockPairCreate", [], __options);
	}

	/**
	 * setFeeTo
	 *
	 * @param { ArgumentTypes.AccountId } feeTo,
	*/
	"setFeeTo" (
		feeTo: ArgumentTypes.AccountId,
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::setFeeTo", [feeTo], __options);
	}

	/**
	 * feeTo
	 *
	*/
	"feeTo" (
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::feeTo", [], __options);
	}

	/**
	 * getPair
	 *
	 * @param { ArgumentTypes.AccountId } tokenA,
	 * @param { ArgumentTypes.AccountId } tokenB,
	*/
	"getPair" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::getPair", [tokenA, tokenB], __options);
	}

	/**
	 * createPair
	 *
	 * @param { ArgumentTypes.AccountId } tokenA,
	 * @param { ArgumentTypes.AccountId } tokenB,
	*/
	"createPair" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::createPair", [tokenA, tokenB], __options);
	}

	/**
	 * lockPairCreate
	 *
	*/
	"lockPairCreate" (
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::lockPairCreate", [], __options);
	}

	/**
	 * allPairs
	 *
	 * @param { (number | string | BN) } pid,
	*/
	"allPairs" (
		pid: (number | string | BN),
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::allPairs", [pid], __options);
	}

	/**
	 * getBootstrap
	 *
	 * @param { ArgumentTypes.AccountId } tokenA,
	 * @param { ArgumentTypes.AccountId } tokenB,
	*/
	"getBootstrap" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::getBootstrap", [tokenA, tokenB], __options);
	}

	/**
	 * setBootstrap
	 *
	 * @param { ArgumentTypes.AccountId } tokenA,
	 * @param { ArgumentTypes.AccountId } tokenB,
	 * @param { ArgumentTypes.AccountId } bootstrap,
	*/
	"setBootstrap" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		bootstrap: ArgumentTypes.AccountId,
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::setBootstrap", [tokenA, tokenB, bootstrap], __options);
	}

	/**
	 * setFeeToSetter
	 *
	 * @param { ArgumentTypes.AccountId } feeToSetter,
	*/
	"setFeeToSetter" (
		feeToSetter: ArgumentTypes.AccountId,
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "factory::setFeeToSetter", [feeToSetter], __options);
	}

	/**
	 * owner
	 *
	*/
	"owner" (
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "ownable::owner", [], __options);
	}

	/**
	 * renounceOwnership
	 *
	*/
	"renounceOwnership" (
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "ownable::renounceOwnership", [], __options);
	}

	/**
	 * transferOwnership
	 *
	 * @param { ArgumentTypes.AccountId } newOwner,
	*/
	"transferOwnership" (
		newOwner: ArgumentTypes.AccountId,
		__options: GasLimit,
	){
		return buildSubmittableExtrinsic( this.__apiPromise, this.__nativeContract, "ownable::transferOwnership", [newOwner], __options);
	}

}
